module.exports = __webpack_public_path__ + "static/media/Jothy-labs.7b76b2e4.png";